import { Tooltip } from "antd";
import { ColumnType } from "antd/es/table";

import {
  TRANSACTION_TYPE_TEXT,
  BidEntity,
  BidTransactionGridDto,
  WalletRiskLevel,
  RISK_LEVELS,
  TransactionType,
  RISK_STATUS_TEXTS,
  RISK_STATUS_ENUM,
} from "interfaces";
import { Status, TxButton } from "ui";
import {
  dateFormat,
  EXPLORER_LINK_TYPE,
  formatWithDecimals,
  getBlockchainExplorerLink,
  getNetworkDecimalPlaces,
} from "utils";
import { UserStore } from "stores/UserStore";
import { DetailReportButton } from "pages/AmlChecksPage/DetailReport";
import { EmptyString } from "constants/strings";
import { ApproveTransactionButton } from "./ApproveTransaction";

export const getColumns = (user: UserStore, bidCard: BidEntity): Array<ColumnType<BidTransactionGridDto>> => {
  const { isSeniorOperator, isJuniorOperator, isRiskManager } = user.roles;

  const isOperator = isSeniorOperator || isJuniorOperator || isRiskManager;

  return [
    {
      dataIndex: "hash",
      key: "hash",
      title: "Хэш",
      width: 180,
      render: (_: any, record: BidTransactionGridDto) => {
        return bidCard.network ? (
          <TxButton
            text={record.hash}
            href={getBlockchainExplorerLink(bidCard.network, record.hash, EXPLORER_LINK_TYPE.transaction)}
            showCopyBtn
            truncateResponse={false}
            buttonSize="large"
          />
        ) : (
          "Некорректный хеш"
        );
      },
    },
    {
      dataIndex: "type",
      key: "type",
      title: "Тип",
      width: 150,
      // defaultFilteredValue: transactionList.queryParams["type"],
      // filtered: "type" in transactionList.queryParams,
      // filters: getEnumKeys(TRANSACTION_TYPE_TEXT).map((key) => ({
      //   text: TRANSACTION_TYPE_TEXT[key],
      //   value: key,
      // })),
      // filterMultiple: false,
      // filterIcon: (filtered: boolean) => getFilterIcon(filtered),
      // render: (type: TransactionType) => {
      //   return TRANSACTION_TYPE_TEXT[type];
      // },
      render: (type: TransactionType) => {
        return TRANSACTION_TYPE_TEXT[type];
      },
    },
    {
      dataIndex: "amount",
      key: "amount",
      width: 200,
      title: "Сумма",
      align: "left",
      // sorter: { multiple: 1 },
      // sortOrder: transactionList?.sorters?.amount && REVERSE_ORDER_MAP[transactionList.sorters.amount],
      // sortIcon: getSortIcon,
      // className: `text-clamp-ellipsis ${styles.amount}`,
      render: (_: any, record: BidTransactionGridDto) => {
        const amount = formatWithDecimals(record.amount, record.currency === "NATIVE" ? 3 : undefined);
        const currency = record.currency === "NATIVE" ? bidCard.network : bidCard.currency;
        return (
          <Tooltip placement="topLeft" title={amount}>
            {amount} {currency}
          </Tooltip>
        );
      },
    },
    isOperator && {
      dataIndex: "riskLevel",
      key: "riskLevels",
      title: "Уровень риска",
      width: 140,
      align: "left",
      render: (riskLevel: WalletRiskLevel) => {
        return riskLevel ? (
          <Status color={RISK_LEVELS.colors[riskLevel]} children={RISK_LEVELS.texts[riskLevel]} alignRight={false} />
        ) : (
          <Status color={"gray"} children={"Не проверялась"} alignRight={false} />
        );
      },
    },
    isOperator && {
      dataIndex: "resolution",
      key: "resolution",
      title: "Статус проверки",
      width: 200,
      align: "left",
      render: (_: any, record: BidTransactionGridDto) => {
        if (record.riskStatus === RISK_STATUS_ENUM.APPROVE_NEEDED) {
          if (record.currency === "NATIVE" || record.type === "OUT") {
            return EmptyString;
          }
          if (isRiskManager && record.riskStatus !== RISK_STATUS_ENUM.NOT_USED && record.type === "IN") {
            return (
              <>
                <ApproveTransactionButton hash={record.hash} />
              </>
            );
          }
        }
        if (record.riskStatus) {
          const approveNeeded = record.riskStatus === RISK_STATUS_ENUM.APPROVE_NEEDED;
          return (
            <Status
              color={approveNeeded ? "yellow" : "gray"}
              children={<span>{approveNeeded ? "⚠️ Требует согласования" : RISK_STATUS_TEXTS[record.riskStatus]}</span>}
              alignRight={false}
            />
          );
        }

        return EmptyString;
      },
    },
    {
      dataIndex: "date",
      key: "date",
      width: 150,
      title: "Дата",
      align: "left",
      // sorter: { multiple: 3 },
      // sortOrder: transactionList?.sorters?.date && REVERSE_ORDER_MAP[transactionList.sorters.date],
      // sortIcon: getSortIcon,
      render: (_: any, record: BidTransactionGridDto) => {
        return dateFormat(record.date, true);
      },
    },
    isOperator && {
      dataIndex: "checkId",
      key: "checkId",
      title: "",
      width: 50,
      render: (_: any, record: BidTransactionGridDto) => {
        return record.checkId ? <DetailReportButton checkId={record.checkId} type="tx" /> : EmptyString;
      },
    },
  ].filter((c) => !!c) as Array<ColumnType<BidTransactionGridDto>>;
};
